<template>
  <div>
    <div class="pa-1">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm7 class="pr-4">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="purchaseByAgeSeries">
            <apexchart
              ref="purchaseByAgeChart"
              type="pie"
              :width="chartWidth"
              :options="purchaseByAgeChart"
              :series="purchaseByAgeSeries"
            >
            </apexchart>
          </template>
        </v-flex>
        <v-flex xs12 sm5 class="pl-4">
          <OverviewFilter @onFilter="onFilter"></OverviewFilter>
        </v-flex>
      </v-layout>
    </div>
    <div class="mt-5">
      <v-data-table :headers="headers" :items="purchaseByAgeShopData" hide-actions>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.name }}</td>
            <td class="text-left">{{ props.item.count }}</td>
            <td class="text-left">{{ props.item.percent }} %</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import DashboardGraphLoading from '@/components/view/dashboard/DashboardGraphLoading'
import OverviewFilter from './OverviewFilter.vue'

export default {
  props: ['selectedDate'],
  data: function () {
    return {
      loading: false,
      filter: {
        product: '',
        model: '',
        headtype: '',
        color: '',
        size: ''
      },

      purchaseByAgeSeries: [],
      purchaseByAgeChart: {
        chart: {
          width: '100%',
          type: 'pie'
        },
        labels: [],
        legend: {
          position: 'left'
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -40
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opt) {
            const name = opt.w.globals.labels[opt.seriesIndex]
            return name + ' : ' + parseFloat(val).toFixed(2) + '%'
          }
        }
      },

      headers: [
        { text: 'Shop', value: 'name' },
        { text: 'Count', value: 'count' },
        { text: '%', value: 'percent' }
      ],
      purchaseByAgeShopData: []
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    OverviewFilter
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    chartWidth() {
      if (window.innerWidth < 500) {
        return 300
      } else {
        return 500
      }
    }
  },
  mounted: function () {
    if (this.selectedDate) {
      this.getPurchaseByAge()
    }
  },
  methods: {
    getPurchaseByAge() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid, // required
        start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
        end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD'), // YYYY-MM-DD
        product: vm.filter.product,
        model: vm.filter.model,
        headtype: vm.filter.headtype,
        colour: vm.filter.color,
        size: vm.filter.size
      }

      vm.loading = true
      api.getLamyOverview1Age(data, (err, response) => {
        if (response && response.responsecode == 200) {
          if (response.data.length > 0) {
            var age = response.data[0].age
            let labelAge = []
            let dataAge = []

            $.each(age, function (index, val) {
              labelAge.push(val.age)
              dataAge.push(val.count)
            })

            vm.$nextTick(function () {
              if (vm.$refs.purchaseByAgeChart) {
                vm.$refs.purchaseByAgeChart.updateOptions({
                  labels: labelAge
                })
                vm.purchaseByAgeSeries = dataAge
              }
            })

            vm.purchaseByAgeShopData = response.data[0].customer_location
          } else {
            let labelAge = []
            let dataAge = []

            vm.$nextTick(function () {
              if (vm.$refs.purchaseByAgeChart) {
                vm.$refs.purchaseByAgeChart.updateOptions({
                  labels: labelAge
                })
                vm.purchaseByAgeSeries = dataAge
              }
            })

            vm.purchaseByAgeShopData = []
          }

          vm.loading = false
        } else {
          console.log(err)
          return
        }
      })
    }, //end getPurchaseByAge()
    onFilter(payload) {
      this.filter = {
        product: payload.product,
        model: payload.model,
        headtype: payload.headtype,
        color: payload.color,
        size: payload.size
      }
      this.getPurchaseByAge()
    }
  },
  watch: {
    loading: function () {},
    selectedDate: {
      handler: function (newValue) {
        this.getPurchaseByAge()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PurchaseBehavior/PurchaseByAge.vue